import React from "react";
import { useNavigate } from "react-router";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { ReactComponent as HappyFace } from "../../../assets/new-icons/ricaricabileFace.svg";
import { useSelector } from "react-redux";

function Ricaricabile() {
  const navigate = useNavigate();
  const selectorUser = useSelector((user) => user.user);
  const saldoPositivo = selectorUser.nuoviDatiContratto.mono_positivo;
  const defaultMethod = selectorUser.payMethodDefault;
  const iban = selectorUser.datiPagamento.account_iban;
  const token = selectorUser.datiPagamento.token;
  const taglia = selectorUser.importo_taglia;
  const soglia = selectorUser.importo_soglia;
  const saldoEnrica = selectorUser.currentBalanceEnrica;

  return (
    <div className="infoBox boxInfo" onClick={() => navigate("/enrica/il-tuo-piano")}>
      <div className="customRow">
        <div className={`icon green`}>
          <HappyFace />
        </div>
        {/* In test si vedrà sempre verde perché ho l'offerta dipendenti */}
        <p className="tipologia">Il nostro prezzo migliore!</p>
        <div className="arrow">
          <ArrowForwardIosIcon />
        </div>
      </div>
      <div className="customRow">
        <div className="empty"></div>
        <div className="columnCard">
          <p className="tipologia">
            Il tuo saldo comprensivo dei consumi giornalieri è di{" "}
            {parseFloat(saldoEnrica).toFixed(2).replace(/\./g, ",")}
          </p>
          <p className="paghi">
            Ogni volta che il tuo Saldo Giornaliero scende sotto la soglia di{" "}
            {soglia} € ricaricheremo la taglia di {taglia} € da:
            {defaultMethod && defaultMethod === "RID"
              ? `conto corrente **** ${
                  iban !== null ? iban.slice(iban.length - 4) : null
                }`
              : ` carta di credito: **** ${
                  token !== null ? token.slice(token.length - 4) : null
                }`}
          </p>
          <p className="price green">PUN + Spread</p>
        </div>
      </div>
    </div>
  );
}

export default Ricaricabile;
